let store;
const noopStore = {
    getItem: function () { },
    setItem: function () { }
};
if (typeof window !== 'undefined' && 'localStorage' in window) {
    try {
        const key = '__pushtell_react__';
        window.localStorage.setItem(key, key);
        if (window.localStorage.getItem(key) !== key) {
            store = noopStore;
        }
        else {
            window.localStorage.removeItem(key);
            store = window.localStorage;
        }
    }
    catch (e) {
        store = noopStore;
    }
}
else {
    store = noopStore;
}
export default store;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmUuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3RvcmUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtBLElBQUksS0FBMEIsQ0FBQTtBQUU5QixNQUFNLFNBQVMsR0FBYztJQUMzQixPQUFPLEVBQUUsY0FBYyxDQUFDO0lBQ3hCLE9BQU8sRUFBRSxjQUFjLENBQUM7Q0FDekIsQ0FBQTtBQUVELElBQUksT0FBTyxNQUFNLEtBQUssV0FBVyxJQUFJLGNBQWMsSUFBSSxNQUFNLEVBQUU7SUFDN0QsSUFBSTtRQUNGLE1BQU0sR0FBRyxHQUFHLG9CQUFvQixDQUFBO1FBQ2hDLE1BQU0sQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLEdBQUcsRUFBRSxHQUFHLENBQUMsQ0FBQTtRQUNyQyxJQUFJLE1BQU0sQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxLQUFLLEdBQUcsRUFBRTtZQUM1QyxLQUFLLEdBQUcsU0FBUyxDQUFBO1NBQ2xCO2FBQU07WUFDTCxNQUFNLENBQUMsWUFBWSxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsQ0FBQTtZQUNuQyxLQUFLLEdBQUcsTUFBTSxDQUFDLFlBQVksQ0FBQTtTQUM1QjtLQUNGO0lBQUMsT0FBTyxDQUFDLEVBQUU7UUFDVixLQUFLLEdBQUcsU0FBUyxDQUFBO0tBQ2xCO0NBQ0Y7S0FBTTtJQUNMLEtBQUssR0FBRyxTQUFTLENBQUE7Q0FDbEI7QUFFRCxlQUFlLEtBQUssQ0FBQSJ9